import type { AttributeInput, CartLineInput } from '@ifixit/shopify-storefront-client';
import type { CartLineItem } from '../types';

/**
 * Line attributes that say where a line came from: `_added_from` names the add
 * to cart that put it in the cart, and `_clicked_from` the product list the
 * visitor clicked the product in before adding it on its product page.
 * Shopify copies line attributes onto the order's line item as properties, so
 * sales can be credited to the button or list without GA4. Shopify hides
 * properties whose key starts with an underscore from customers at checkout.
 * cart-fields.fragment.graphql reads both back by these keys.
 */
const ADDED_FROM_ATTRIBUTE_KEY = '_added_from';
const CLICKED_FROM_ATTRIBUTE_KEY = '_clicked_from';

export function toCartLineInput(line: CartLineItem, addedFrom = line.addedFrom): CartLineInput {
   const attributes: AttributeInput[] = [];
   if (addedFrom) {
      attributes.push({ key: ADDED_FROM_ATTRIBUTE_KEY, value: addedFrom });
   }
   if (line.clickedFrom) {
      attributes.push({ key: CLICKED_FROM_ATTRIBUTE_KEY, value: line.clickedFrom });
   }
   return {
      merchandiseId: line.shopifyVariantId,
      quantity: line.quantity,
      sellingPlanId: line.sellingPlanId,
      attributes: attributes.length > 0 ? attributes : undefined,
   };
}
